"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var util_1 = require("../../util");
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onMessage = function (args) {
            //监听登录完成后的消息: args.action == "loginResult"
            console.log('登录相关的消息 >>> ', args);
            var _a = _this.props, onLoginSuccess = _a.onLoginSuccess, onLoginFindPwd = _a.onLoginFindPwd, onMessage = _a.onMessage;
            if (args.action && args.action === "loginResult" && args.resultCode === '100') {
                // args包含以下属性:
                // args.action: 固定为"loginResult"
                // args.resultCode: 固定为100, 代表成功, 登录不成功不会发送事件.
                // args.loginId: 为用户登录框中填写的登录外标, 可能为"登录手机", "登录邮箱", "登录昵称"
                // args.token: 为用户登录完成后openaccount颁发的一次性token, 可以根据该token调用openaccount服务验证token, 拿到登录用户id等信息
                // @登录成功回调函数一定要有
                onLoginSuccess(args);
            }
            // 当嵌入iframe时将addResetPwdUrl属性设置为true时才需要监听找密消息
            // 监听找密消息: args.action == "resetpwd"
            if (args.action && args.action === "resetpwd" && args.resultCode === '100') {
                onLoginFindPwd(args);
            }
            onMessage(args);
        };
        _this.initLogin = function (props) {
            if (props === void 0) { props = _this.props; }
            var appKey = props.appKey, iframeUrl = props.iframeUrl, iframeWidth = props.iframeWidth, iframeHeight = props.iframeHeight, custom = props.custom, lang = props.lang;
            var config = __assign({ appKey: appKey, iframeUrl: iframeUrl, lang: lang || 'zh_CN', iframeWidth: iframeWidth,
                iframeHeight: iframeHeight, resizeIframeHeightFix: true, styleType: 'auto' }, custom);
            document.getElementById('alibaba-login-iframe-box').remove();
            var domNode = document.createElement('div');
            var domLoading = document.createElement('div');
            domNode.id = 'alibaba-login-iframe-box';
            domLoading.id = 'alibaba-login-iframe-loading';
            document.getElementById('alibaba-login-container').append(domNode);
            document.getElementById('alibaba-login-iframe-box').append(domLoading);
            var options = __assign({ targetId: 'alibaba-login-iframe-box' }, config);
            _this.miniLoginEmbedder.init(options);
        };
        return _this;
    }
    Login.prototype.componentDidMount = function () {
        var _this = this;
        util_1.insertScript("https://g.alicdn.com/vip/open-account/0.4.5/js/mini-login-embedderV3.js")
            .then(function () {
            _this.miniLoginEmbedder = new window.MiniLoginEmbedder();
            _this.initLogin();
            _this.miniLoginEmbedder.addEvent('onMessage', function (args) {
                _this._onMessage(args);
            });
        });
    };
    Login.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.iframeUrl !== this.props.iframeUrl) {
            // this.miniLoginEmbedder.destory();
            this.initLogin(nextProps);
        }
    };
    Login.prototype.render = function () {
        return react_1.default.createElement("div", { id: "alibaba-login-container" },
            react_1.default.createElement("div", { id: "alibaba-login-iframe-box" },
                react_1.default.createElement("div", { id: "alibaba-login-iframe-loading" })));
    };
    return Login;
}(react_1.Component));
exports.default = Login;
Login.propTypes = {
    // 登录成功回调函数
    onLoginSuccess: prop_types_1.default.func,
    // 查找密码回调函数
    onLoginFindPwd: prop_types_1.default.func,
    // 回调
    onMessage: prop_types_1.default.func,
    // 对接oa系统的appkey 一定要有
    appKey: prop_types_1.default.string,
    // 国际化语言
    lang: prop_types_1.default.string,
    // 登录模板
    iframeUrl: prop_types_1.default.string,
    // 登录框宽高
    iframeWidth: prop_types_1.default.string,
    iframeHeight: prop_types_1.default.string,
    custom: prop_types_1.default.object,
};
Login.defaultProps = {
    onLoginSuccess: function () { },
    onLoginFindPwd: function () { },
    onMessage: function () { },
    iframeUrl: null,
    iframeWidth: 280,
    iframeHeight: 236,
    custom: {},
};
